import React, { useEffect, useState } from "react";
import { AsyncSelect } from "@caelor/ui";
import { searchSpaces } from "../../../api/confluence-api";
import { getSpacesByKey } from "../../../api/space-api";
import { useTranslation } from "react-i18next";

export const CurrentSpaceOption = {
  icon: undefined,
  name: "Current Space",
  spaceKey: "current-space-hardcoded",
  type: "space",
  label: "Current Space",
  value: "current-space-hardcoded",
  homepageId: "undefined",
  coverPictureCallback: async () => {},
};

function mapSpace(space) {
  return {
    icon: space.icon,
    name: space.name,
    spaceKey: space.key,
    spaceId: space.id,
    type: "space",
    label: space.name,
    value: space.key,
    homepageId: space.homepage.id,
    coverPictureCallback: async () => {},
  };
}

function mapSpaceV2(space) {
  return {
    icon: space.icon,
    name: space.name,
    spaceKey: space.key,
    spaceId: space.id,
    type: "space",
    label: space.name,
    value: space.key,
    homepageId: space.homepageId,
    coverPictureCallback: async () => {},
  };
}

const SpacePicker = ({
  initialSpaces,
  onUpdate,
  isMulti = false,
  placeholder,
  hasCurrentSpaceAsOption = false,
  isSpaceManual = false,
}) => {
  const { t } = useTranslation();
  const [selectedSpaces, setSelectedSpaces] = useState([]);

  useEffect(() => {
    if ((initialSpaces ?? []).length > 0) {
      const isCurrentSpaceOptionSelected =
        hasCurrentSpaceAsOption &&
        !!initialSpaces.find(
          (spaceKey) => spaceKey === CurrentSpaceOption.spaceKey
        );

      const fetchSpacesKeys = [];
      for (const spaceKey of initialSpaces) {
        if (spaceKey !== CurrentSpaceOption.spaceKey) {
          fetchSpacesKeys.push(spaceKey);
        }
      }
      getSpacesByKey(fetchSpacesKeys)
        .then((res) => {
          const results = JSON.parse(res.body)?.results || [];
          const mappedResults = results.map((r) => mapSpaceV2(r));
          if (isCurrentSpaceOptionSelected) {
            mappedResults.splice(0, 0, CurrentSpaceOption);
          }
          setSelectedSpaces([...mappedResults]);
        })
        .catch((e) => {});
    } else {
      setSelectedSpaces([]);
    }
  }, [initialSpaces, hasCurrentSpaceAsOption]);

  const loadOptions = async (query) => {
    try {
      const response = await searchSpaces(query);

      const data = JSON.parse(response.body);
      const options = data.results.map(({ space }) => mapSpace(space));

      if (hasCurrentSpaceAsOption) {
        options.splice(0, 0, CurrentSpaceOption);
      }

      return options.filter((space) => {
        if (!initialSpaces.length) return true;
        return !initialSpaces.find((spaceKey) => spaceKey === space.spaceKey);
      });
    } catch (error) {
      return [];
    }
  };

  return (
    <AsyncSelect
      isSearchable
      placeholder={placeholder || t("select-spaces")}
      isClearable
      onChange={(e) => {
        if (e === undefined) {
          setSelectedSpaces([]);
          onUpdate([]);
          return;
        }
        if (isMulti) {
          setSelectedSpaces(e);
          onUpdate(e.map((s) => s.spaceKey));
          return;
        }
        setSelectedSpaces([e]);
        onUpdate(e);
      }}
      value={isSpaceManual ? [] : selectedSpaces}
      isMulti={isMulti}
      loadOptions={loadOptions}
    />
  );
};

export default SpacePicker;
